import _ from 'lodash'
import log from 'loglevel'

import apiConfig from './api'
import modulesConfig from './modules'
import languagesConfig from './languages'
import componentsConfig from './components'
import toastrConfig from './toastr'

// LOAD ENV CONFIG
const envNodeConfig = require('./enviromentNode/config.js').default // eslint-disable-line

// LOAD ASSEMBLY CONFIG
const envAssemblyConfig = require('./enviromentAssembly/config.js').default // eslint-disable-line

// LOAD API URLs OBJECT FROM ENV CONFIG
const api = _.get(envNodeConfig, 'api')

/**
 * DEFAULT CONFIG
 */
const defaults = {
    // default configuration goes here
    devTools: false,
    logLevel: log.levels.ERROR,
    iframeSolution: false,
    betterPerformance: false,
    batchNotify: true,
    history: {
        basename: '/',
    },
}

/**
 * MERGE ALL CONFIGS TOGETHER
 */
const config = _.merge(
    defaults,
    apiConfig(api.orcV2, api.orcV1, api.gnosRest, api.centipedeRest, api.ciaNewsBase),
    modulesConfig,
    languagesConfig,
    componentsConfig,
    toastrConfig,
    envNodeConfig,
    envAssemblyConfig
)

export default config
